<template>
  <el-input
    v-if="hide"
    type="password"
    v-model="password"
    ref="password"
    :id="id"
    :maxlength="maxlength"
    :disabled="disabled"
    :placeholder="placeholder"
    @change="change"
  >
    <i
      v-if="showPassword"
      :id="iconId"
      slot="suffix"
      class="fa fa-eye-slash"
      @click="hide = false"
    ></i>
  </el-input>
  <el-input
    v-else-if="showPassword"
    type="text"
    v-model="password"
    ref="password"
    :id="id"
    :maxlength="maxlength"
    :disabled="disabled"
    :placeholder="placeholder"
    @change="change"
  >
    <i :id="iconId" slot="suffix" class="el-icon-view" @click="hide = true"></i>
  </el-input>
</template>
<script>
export default {
  props: {
    id: {
      type: String,
      default: "pwd",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: Number,
      default: 256,
    },
    placeholder: {
      type: String,
      default: "",
    },
    config: {
      type: String,
      default: "",
    },
    iconId: {
      type: String,
      default: "pwd_display",
    },
    showPassword: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      hide: true,
      password: "",
    };
  },
  watch: {
    config: {
      handler() {
        this.password = this.config;
      },
      immediate: true,
    },
  },
  methods: {
    change() {
      this.$emit("update:config", this.password);
      this.$emit("change");
    },
  },
};
</script>
